import { useThemeContext } from 'contexts/theme';
import { useUserContext } from 'contexts';
import ExprealtyCaIcon from 'components/icon/exprealty-ca-icon';
import ZoocasaIcon from 'components/icon/zoocasa-icon';
import ZoocasaUsaIcon from 'components/icon/zoocasa-usa-icon';
import { CountryCodeList } from 'types/countries';
import ExpInServiceIcon from 'components//icon/exp-in-service-icon';
import ExpCommercialIcon from 'components/icon/exp-commercial-icon';
import { EXP_COMMERCIAL_TENANT_ID, EXP_IN_SERVICE_TENANT_ID, EXP_REALTY_CA_TENANT_ID, EXP_REALTY_US_TENANT_ID } from '@tenants/types';

type ThemedIconProps = {
  className?: string;
  onClick?: () => void;
};

export default function ThemedIcon({ className, onClick }: ThemedIconProps) {
  const { siteLocation } = useUserContext();
  const isUsSite = siteLocation === CountryCodeList.UNITED_STATES;
  const { tenantId } = useThemeContext();

  switch (tenantId) {
    case EXP_IN_SERVICE_TENANT_ID:
      return <ExpInServiceIcon className={className} onClick={onClick} />;
    case EXP_REALTY_CA_TENANT_ID:
    case EXP_REALTY_US_TENANT_ID:
      return <ExprealtyCaIcon className={className} onClick={onClick} />;
    case EXP_COMMERCIAL_TENANT_ID:
      return <ExpCommercialIcon className={className} onClick={onClick} />;
    default:
      return isUsSite
        ? <ZoocasaUsaIcon className={className} onClick={onClick} />
        : <ZoocasaIcon className={className} onClick={onClick} />;
  }
}
